import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrugManagementComponent } from './components/drug-management.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from 'src/app/shared/shared.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTableModule } from '@angular/cdk/table';
import { MatSortModule } from '@angular/material/sort';
import { MatListModule} from '@angular/material/list';
import { MatCardModule} from '@angular/material/card';
import {MatDividerModule} from '@angular/material/divider';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DrugManagementRoutingModule } from './drug-management-routing.module';
import { SynmedFileuploadComponent } from './components/synmed-fileupload/synmed-fileupload.component';
import { SnapcanisterFileuploadComponent } from './components/snapcanister-fileupload/snapcanister-fileupload.component';
import { PetmedFileuploadComponent } from './components/petmed-fileupload/petmed-fileupload.component';
import { DrugListComponent } from './components/drug-list/drug-list.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { ImportWizardDrugDetailsComponent } from './components/import-wizard-drug-details/import-wizard-drug-details.component';
import { ImportWizardAddNewDrugComponent } from './components/import-wizard-add-new-drug/import-wizard-add-new-drug.component';
import { ImportWizardInventoryComponent } from './components/import-wizard-inventory/import-wizard-inventory.component';
import { ImportWizardImageSlideComponent } from './components/import-wizard-image-slide/import-wizard-image-slide.component';
import { CddbAutomationScriptComponent } from './components/cddb-automation-script/cddb-automation-script.component';
import { QuarantinedDrugListComponent } from './components/quarantined-drug-list/quarantined-drug-list.component';
import { SearchDrugListComponent } from './components/search-drug-list/search-drug-list.component';
import { ImportWizardQuarantinedDrugListComponent } from './components/import-wizard-quarantined-drug-list/import-wizard-quarantined-drug-list.component';
import { ImportWizardSearchDrugComponent } from './components/import-wizard-search-drug/import-wizard-search-drug.component';
import { ImportWizardAlertComponent } from './components/import-wizard-alert/import-wizard-alert.component';
import { NumberValidatorDirective } from './directives/positive-number-validator.directive';
import { DigitLengthValidatorDirective } from './directives/digit-length-validator.directive';
import { NoLeadingSpaceDirective } from './directives/no-leading-space-validator.directive';
import { NewDrugListComponent } from './components/new-drug-list/new-drug-list.component';
import { DcrDrugListComponent } from './components/dcr-drug-list/dcr-drug-list.component';
import { ImportWizardDcrDrugListComponent } from './components/import-wizard-dcr-drug-list/import-wizard-dcr-drug-list.component';
import { ImportWizardDrugClassificationResolutionComponent } from './components/import-wizard-drug-classification-resolution/import-wizard-drug-classification-resolution.component';
import { ImportWizardPillIdDetailsComponent } from './components/import-wizard-pill-id-details/import-wizard-pill-id-details.component';
import { OtherBottleSizeWizardComponent } from './components/other-bottle-size-wizard/other-bottle-size-wizard.component';
import { ColorChipAutoCompleteDetailsModule } from './components/color-chip-autocomplete-details/color-chip-autocomplete-details.module';
import { MergeQuarantineDrugWizardComponent } from './components/merge-quarantine-drug-wizard/merge-quarantine-drug-wizard.component';
import { ImportWizardNewDrugComponent } from './components/import-wizard-new-drug/import-wizard-new-drug.component';
import { MatStepperModule } from '@angular/material/stepper';
import { TruncateAfterPipe } from '../im-tool/pipes/truncate-after.pipe';


@NgModule({
  declarations: [
    DrugManagementComponent,
    SynmedFileuploadComponent,
    SnapcanisterFileuploadComponent,
    PetmedFileuploadComponent,
    DrugListComponent,
    FileUploadComponent,
    ImportWizardDrugDetailsComponent,
    ImportWizardAddNewDrugComponent,
    ImportWizardNewDrugComponent,
    ImportWizardInventoryComponent,
    ImportWizardImageSlideComponent,
    CddbAutomationScriptComponent,
    QuarantinedDrugListComponent,
    SearchDrugListComponent,
    ImportWizardQuarantinedDrugListComponent,
    ImportWizardSearchDrugComponent,
    ImportWizardAlertComponent,
    NewDrugListComponent,
    NumberValidatorDirective,
    DigitLengthValidatorDirective,
    NoLeadingSpaceDirective,
    DcrDrugListComponent,
    ImportWizardDcrDrugListComponent,
    ImportWizardDrugClassificationResolutionComponent,
    ImportWizardPillIdDetailsComponent,
    OtherBottleSizeWizardComponent,
    MergeQuarantineDrugWizardComponent,
    TruncateAfterPipe
  ],

  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    ScrollingModule,
    CdkTableModule,
    MatSortModule,
    MatTableModule,
    MatProgressSpinnerModule,
    DrugManagementRoutingModule,
    MatListModule,
    MatCardModule,
    MatDividerModule,
    ColorChipAutoCompleteDetailsModule,
    MatStepperModule,
  ],
})
export class DrugManagementModule { }


